import axios from "axios";
import { useEffect, useState } from "react";

const useGetImages = (picture, firmaId, categoryId) => {
  const [image, setImage] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        setIsLoading(true);
        const response = await axios.get(
          `https://1zw31qczi7.execute-api.eu-central-1.amazonaws.com/prod/${picture}/${firmaId}/${categoryId}`
        );
        setImage(response?.data);
      } catch (err) {
        console.log(err.response);
        setError(err.response);
      } finally {
        setIsLoading(false);
      }
    })();
  }, [categoryId]);

  return { image, isLoading, error };
};

export default useGetImages;
